import { render, staticRenderFns } from "./DialogAuth.vue?vue&type=template&id=284488b5"
import script from "./DialogAuth.vue?vue&type=script&lang=js"
export * from "./DialogAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports